export function formatFileSize(value) {
  if (value === null || value === undefined || value === '') return 'N/A';

  const num = Number(value);
  if (Number.isNaN(num)) return value;

  if (num < 1024) return `${num} B`;

  const units = ['KB', 'MB', 'GB', 'TB'];
  let size = num / 1024;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex += 1;
  }

  return `${size.toFixed(size >= 10 ? 0 : 1)} ${units[unitIndex]}`;
};

export function formatFileDate(timestamp) {
  const date = new Date(timestamp);
  return date.toLocaleString();
};

export function isOnlyEmojis(str){

  if (!str || !str.trim())
    return false;

  const emojiRegex =
    /^[\s\p{Emoji}\p{Emoji_Modifier}\p{Emoji_Component}\p{Emoji_Modifier_Base}\p{Emoji_Presentation}]+$/u;

  const cleanStr =
    str.replace(/[0-9#*]/g,"").trim();

  return (
    cleanStr.length > 0 &&
    emojiRegex.test(cleanStr)
  );
};